import { useEffect, useState } from "react";
import { ISociosChart } from "../../../interfaces/SociosChart";
import { getSociosDataProgramas } from "../../../api/sociosChart";
import { useTranslation } from "react-i18next";
import PieChart from "../../../components/Charts/PieChart";
import { ChartContainerLoader } from "../../../components/Generic/Charts";

const Intro: React.FC<{ code: string }> = ({ code }) => {
  const { t } = useTranslation("translation", { keyPrefix: "intro" });

  const [sociosData, setSociosData] = useState<ISociosChart[]>();

  useEffect(() => {
    getSociosDataProgramas(code).then((res) => {
      setSociosData(res);
      return;
    });
  }, [code]);
  if (!sociosData) {
    return <ChartContainerLoader colSize={"12"} />;
  }
  return (
    <div className="row">
      <div className="row">
        <PieChart chartName={t("socios")} data={sociosData!} />
      </div>
    </div>
  );
};

export default Intro;
